import { useParams } from 'react-router-dom';

type ProjectFile = { name: string; content: string };

function getContentType(name: string): string {
  if (name.endsWith('.js') || name.endsWith('.jsx') || name.endsWith('.ts') || name.endsWith('.tsx')) return 'application/javascript';
  if (name.endsWith('.css')) return 'text/css';
  if (name.endsWith('.json')) return 'application/json';
  return 'text/plain';
}

export default function SandboxFile() {
  const { sessionId, '*': filePath } = useParams<{ sessionId: string; '*': string }>();
  if (!sessionId || !filePath) throw new Response('Missing params', { status: 400 });

  const filesKey = `dayone:sandbox:files:${sessionId}`;
  const filesStr = localStorage.getItem(filesKey);
  if (!filesStr) throw new Response('No files', { status: 404 });

  const files: ProjectFile[] = JSON.parse(filesStr);
  const file = files.find(f => f.name === filePath);
  if (!file) throw new Response('File not found', { status: 404 });

  throw new Response(file.content, { headers: { 'Content-Type': getContentType(file.name) } });
}